import type { Cue } from './model/cue.ts';

/** Closed interval [start, end] — mirrors render.js / shortcut.js cue matching (B-MATCH-01). */
export function activeCuesAt(subs: Cue[], currentTimeMs: number): Cue[] {
  return subs.filter((cue) => cue.start <= currentTimeMs && currentTimeMs <= cue.end);
}

/** Effective playback time for matching when a slot delay is applied (B-DELAY-01). */
export function effectiveMatchTime(videoTimeMs: number, delayMs: number): number {
  return videoTimeMs + delayMs;
}
